package com.wsa.hawebapp

/** Represents a discovered BLE device. */
data class BleDevice(val id: String, val name: String)

/** Returns `true` if the Web Bluetooth API is available in the current browser. */
expect fun isBluetoothAvailable(): Boolean

/**
 * Opens the browser's native BLE device picker and returns the device the user
 * selects, or `null` if the user cancels or the API is unavailable.
 *
 * Must be called from a user-gesture handler (e.g. button click).
 */
expect suspend fun requestBleDevice(): BleDevice?

/**
 * Returns the list of BLE devices the user has previously granted access to
 * (i.e. already paired/bonded through the browser). Requires the browser to
 * support `bluetooth.getDevices()`. Returns an empty list if unsupported.
 */
expect suspend fun getBondedDevices(): List<BleDevice>